import React from 'react';
import './Footer.scss';

const Footer: React.FC = () => {
  return (
    <div className="footer">
        Footer
    </div>
  )
}

export default Footer;